var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"return"}},[_c('sf-heading',{attrs:{"description":_vm.$t('Payment Return'),"level":2,"title":_vm.$t('loading')}}),_c('OrkLoader',{attrs:{"loading":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }